type BrowserNavigator = Pick<Navigator, 'userAgent'> & { userAgentData?: unknown }

type UserAgentBrand = { brand: string }

const CHROMIUM_BRAND = 'Chromium'
const CHROMIUM_USER_AGENT_TOKENS = ['Chrome/', 'Chromium/', 'Edg/']

const isUserAgentBrand = (value: unknown): value is UserAgentBrand =>
  typeof value === 'object' && value !== null && 'brand' in value && typeof value.brand === 'string'

const getUserAgentBrands = (userAgentData: unknown): UserAgentBrand[] => {
  if (typeof userAgentData !== 'object' || userAgentData === null || !('brands' in userAgentData)) return []
  const { brands } = userAgentData
  return Array.isArray(brands) ? brands.filter(isUserAgentBrand) : []
}

/** Chromium-based browsers only (Chrome, Edge); Safari and Firefox lack userAgentData and the Chrome/ token. */
export const isPrintSupportedBrowser = (navigator: BrowserNavigator): boolean => {
  const brands = getUserAgentBrands(navigator.userAgentData)
  if (brands.length > 0) return brands.some(({ brand }) => brand === CHROMIUM_BRAND)

  return CHROMIUM_USER_AGENT_TOKENS.some((token) => navigator.userAgent.includes(token))
}
